import { render } from "./userProfile.vue?vue&type=template&id=61f331d0&scoped=true"
import script from "./userProfile.vue?vue&type=script&lang=js"
export * from "./userProfile.vue?vue&type=script&lang=js"

import "./userProfile.vue?vue&type=style&index=0&id=61f331d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f331d0"]])

export default __exports__